import { render } from "./AccountManage.vue?vue&type=template&id=a8596e0e&scoped=true&ts=true"
import script from "./AccountManage.vue?vue&type=script&lang=ts"
export * from "./AccountManage.vue?vue&type=script&lang=ts"

import "./AccountManage.vue?vue&type=style&index=0&id=a8596e0e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8596e0e"]])